import { Image, Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import React from "react";
import {
  getLabelTag,
  getLabelTagInput,
  getLabelTagsWithDynamicInputs,
  getTherapyLabelTags,
} from "../constructTextFromValues";
import {
  cardioTherapyOptions,
  // daysUptoFifteenOptions,
  orthoTherapyOptions,
  sportsTherapyOptions,
  weeksStartingFourOptions,
  // weeksStartingTwoOptions,
} from "../../Options/physioOptions";
import therapyIcon from "../../../../assets/doctorIcons/therapy.svg";
import { checkEmpty } from "../../../../helpers/utility";

export const weeksStartingTwoOptions = [
  { label: "2 weeks", value: "2_weeks" },
  { label: "4 weeks", value: "4_weeks" },
  { label: "6 weeks", value: "6_weeks" },
  { label: "8 weeks", value: "8_weeks" },
  { label: "12 weeks", value: "12_weeks" },
];

export const daysUptoFifteenOptions = [
  { label: "7 days", value: "7_days" },
  { label: "10 days", value: "10_days" },
  { label: "15 days", value: "15_days" },
];

const PhysioTherapySummary = ({ formData }) => {
  const filteredOrthoTherapyOptions = orthoTherapyOptions?.filter(
    (option) => !["ultrasound", "splinting"]?.includes(option?.name_key)
  );
  const filteredSportsTherapyOptions = sportsTherapyOptions?.filter(
    (option) => !["ultrasound", "splinting"]?.includes(option?.name_key)
  );
  const constructTherapySummaryItems = () => {
    const therapySummaryItems = [];
    const therapy = formData?.therapy || {};
    const pushTherapyItem = (key, label, children) => {
      therapySummaryItems.push({ key, label, children });
    };
    if (therapy?.cardio) {
      pushTherapyItem(
        "1",
        "Cardio",
        <>
          {getTherapyLabelTags(cardioTherapyOptions, therapy?.cardio_details)}
        </>
      );
    }
    if (therapy?.ortho) {
      pushTherapyItem(
        "2",
        "Ortho",
        <>
          {getTherapyLabelTags(
            filteredOrthoTherapyOptions,
            therapy?.ortho_details
          )}
          {getLabelTagInput(
            "Ultrasound",
            getLabelTag(
              daysUptoFifteenOptions,
              therapy?.ortho_details?.ultrasound
            )
          )}
          {getLabelTagInput(
            "Ultrasound Remarks",
            therapy?.ortho_details?.ultrasound_remarks
          )}
          {getLabelTagInput(
            "Splinting/ Bracing",
            getLabelTag(
              weeksStartingTwoOptions,
              therapy?.ortho_details?.splinting
            )
          )}
          {getLabelTagInput(
            "Splinting/ Bracing Remarks",
            therapy?.ortho_details?.splinting_remarks
          )}
          {getLabelTagInput(
            "Postural Correction",
            therapy?.ortho_details?.postural_correction
          )}
        </>
      );
    }
    if (therapy?.sports) {
      pushTherapyItem(
        "3",
        "Sports",
        <>
          {getTherapyLabelTags(
            filteredSportsTherapyOptions,
            therapy?.sports_details
          )}
          {getLabelTagInput(
            "Ultrasound",
            getLabelTag(
              daysUptoFifteenOptions,
              therapy?.sports_details?.ultrasound
            )
          )}
          {getLabelTagInput(
            "Ultrasound Remarks",
            therapy?.sports_details?.ultrasound_remarks
          )}
          {getLabelTagInput(
            "Splinting/ Bracing",
            getLabelTag(
              weeksStartingTwoOptions,
              therapy?.sports_details?.splinting
            )
          )}
          {getLabelTagInput(
            "Splinting/ Bracing Remarks",
            therapy?.sports_details?.splinting_remarks
          )}
          {getLabelTagInput(
            "Postural Correction",
            therapy?.sports_details?.postural_correction
          )}
        </>
      );
    }
    if (therapy?.neuro) {
      pushTherapyItem(
        "4",
        "Neuro",
        <>
          {getLabelTagInput(
            "Stroke Rehab",
            getLabelTag(
              weeksStartingFourOptions,
              therapy?.neuro_details?.stroke_rehab
            )
          )}
          {getLabelTagInput(
            "Bruntromm Approach",
            therapy?.neuro_details?.brustromme_approach
          )}
          {getLabelTagInput(
            "MRP Approach",
            therapy?.neuro_details?.mrp_approach
          )}
          {getLabelTagInput(
            "NDT Approach",
            therapy?.neuro_details?.ndt_approach
          )}
          {getLabelTagInput(
            "CIMT Approach",
            therapy?.neuro_details?.cimt_approach
          )}
          {getLabelTagInput(
            "VOJTA Approach",
            therapy?.neuro_details?.vojta_approach
          )}
          {getLabelTagInput(
            "PNF Approach",
            therapy?.neuro_details?.pnf_approach
          )}
          {getLabelTagInput(
            "Electic Approach",
            therapy?.neuro_details?.electic_approach
          )}
          {getLabelTagInput(
            "ROODS Approach",
            therapy?.neuro_details?.roods_approach
          )}
          {getLabelTagInput(
            "Speech Therapy",
            therapy?.neuro_details?.speech_therapy
          )}
          {getLabelTagInput(
            "Electical Muscle Stimulation",
            therapy?.neuro_details?.electrical_muscle_stimulation
          )}
          {getLabelTagInput(
            "Mile Stone Training",
            therapy?.neuro_details?.mile_stone_training
          )}
          {getLabelTagInput(
            "Cognitive Rehab",
            therapy?.neuro_details?.cognitive_rehab
          )}
          {getLabelTagInput(
            "Neuro Conditioning Training",
            therapy?.neuro_details?.neuro_conditioning_training
          )}
          {getLabelTagInput(
            "Sensory Integration",
            therapy?.neuro_details?.sensory_integration
          )}
          {getLabelTagInput(
            "ADL Training",
            therapy?.neuro_details?.adl_training
          )}
          {getLabelTagInput(
            "Wheel Chair Training",
            therapy?.neuro_details?.wheel_chair_training
          )}
          {getLabelTagInput(
            "Ultrasound",
            getLabelTag(
              daysUptoFifteenOptions,
              therapy?.neuro_details?.ultrasound
            )
          )}
          {getLabelTagInput(
            "Ultrasound Remarks",
            therapy?.neuro_details?.ultrasound_remarks
          )}
          {getLabelTagInput(
            "Splinting/ Bracing",
            getLabelTag(
              weeksStartingTwoOptions,
              therapy?.neuro_details?.splinting
            )
          )}
          {getLabelTagInput(
            "Splinting/ Bracing Remarks",
            therapy?.neuro_details?.splinting_remarks
          )}
          {getLabelTagInput(
            "Postural Correction",
            therapy?.neuro_details?.postural_correction
          )}
          {getLabelTagInput("Robotics", therapy?.neuro_details?.robotics)}
          {getLabelTagInput(
            "Gait Training",
            therapy?.neuro_details?.gait_training
          )}
          {getLabelTagInput("Description", therapy?.neuro_details?.description)}
        </>
      );
    }
    if (checkEmpty(therapy?.others)) {
      pushTherapyItem(
        "5",
        "Therapy",
        getLabelTagsWithDynamicInputs(therapy?.others)
      );
    }
    return therapySummaryItems;
  };
  const therapySummaryItems = constructTherapySummaryItems();
  return (
    <SummaryWrapper
      items={therapySummaryItems}
      title={
        <span style={{ fontWeight: "500", marginLeft: ".2rem" }}>
          <Space>
            <Image src={therapyIcon} width={"18px"} preview={false} />
            <span>Therapy</span>
          </Space>
        </span>
      }
    />
  );
};

export default PhysioTherapySummary;
